import { useLocalStorage } from 'react-use';
import { useEffect } from 'react';
import { readPendingUserAccountItem } from '@pkgs/components/utils/readPendingUserAccountItem';
import { type PendingUserAccountItem, PendingUserAccountItemType } from '@pkgs/components/types/types';
import { useUserAccount } from '@pkgs/components/hooks/useUserAccount';
import { useAppContext } from '@pkgs/components/hooks/useAppContext';
import { PENDING_USER_ACCOUNT_ITEM_KEY } from '@pkgs/components/consts/consts';
import { useAuth } from '@ev-tech/user-account-modules';
import { type ModalState } from '@ev-tech/ui-core-components/Modal';

export const usePendingUserAccountItemAfterAuth = (searchAlertModalState: ModalState): void => {
  const { events } = useAppContext();
  const { isLoaded, isSignedIn } = useAuth();
  const { state: userAccountState } = useUserAccount();
  const [, , removePendingItemToSave] = useLocalStorage<PendingUserAccountItem | null>(PENDING_USER_ACCOUNT_ITEM_KEY);

  useEffect(() => {
    if (!isLoaded || !isSignedIn || userAccountState.isOpen) return;

    let pendingItem: PendingUserAccountItem | null = null;

    try {
      pendingItem = readPendingUserAccountItem();
    } catch (error) {
      events?.onError?.(new Error('Failed to parse pending user account item', { cause: error }));
    }

    if (pendingItem?.type !== PendingUserAccountItemType.SEARCH_ALERT) return;

    removePendingItemToSave();
    searchAlertModalState.setOpen(true);
  }, [isLoaded, isSignedIn, userAccountState.isOpen, searchAlertModalState, removePendingItemToSave, events]);
};
